import { object, string } from 'yup';
import { CreateCommand } from '../../../entity/RealtimeEvent.js';
import { RealtimeEventType } from '../../../enums.js';

const SCHEMA = object({
  id: string().required(),
  old_table_type: string()
    .oneOf(['expired', 'today', 'afterToday', 'empty', 'completed'])
    .required(),
  new_table_type: string()
    .oneOf(['expired', 'today', 'afterToday', 'empty', 'completed'])
    .required(),
});

/**
 * MySpaceMyTasksUpdateEvent
 *
 * - Evento emitido quando uma tarefa é atualizada no meu espaço.
 */
export class MySpaceMyTasksUpdateEvent extends CreateCommand(
  RealtimeEventType.MySpaceMyTasksUpdate,
  SCHEMA,
) {}
